import styled from '../../theme'
import React from 'react'
import { ITheme } from '../../theme'

type CircleType = React.ComponentType<ICircleProps>
export const Circle: CircleType = styled.div<ICircleProps>`
  width: ${({ size }) => (size ? 18 * size : 18)}px;
  height: ${({ size }) => (size ? 18 * size : 18)}px;
  border-radius: 90% 90%;
  margin-left: ${({ size }) => (size ? 27 * size : 27)}px;
  margin-right: ${({ size }) => (size ? 15 * size : 15)}px;
  background-color: ${props => props.color};
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    margin-left: ${({ size }) => (size ? 15 * size : 15)}px;
  }
`

export interface ICircleProps {
  color: string
  size?: number
}
